import React from "react";
import { useTranslation } from 'react-i18next';
import newChatPnc from "../../assets/newChatPnc.svg";
import feedPnc from "../../assets/feedStarPnc.svg";

const ActionButtons = ({ resetToWelcomePage, handleFeedbackButtonClick, isMobile }) => {
  const { t } = useTranslation();
  
  if (isMobile) {
    return (
      <>
        {/* New Chat button */}
        <div className="py-1">
          <button
            onClick={resetToWelcomePage}
            className="w-full bg-custom text-white rounded-full bg-black border-gray-200 font-medium hover:bg-custom/90 transition-all transform hover:scale-105 focus:outline-none focus:ring-2 focus:ring-custom focus:ring-opacity-50 buttonPncSidebar"
          >
            <div className="flex items-center justify-center space-x-2">
              <img src={newChatPnc} alt="Chat Icon" className="h-5 w-5" />
              <span>{t('newChat')}</span>
            </div>
          </button>
        </div>

        {/* Give Feedback button */}
        <div className="py-2 border-gray-200">
          <button
            onClick={handleFeedbackButtonClick}
            className="w-full flex rounded-full items-center justify-center space-x-2 text-gray-700 border-[#FFCBCB] shadow-md font-medium buttonPncSidebar"
          >
            <img src={feedPnc} alt="Give Feedback icon" className="h-5 w-5" />
            <span>{t('giveFeedback')}</span>
          </button>
        </div>
      </>
    );
  }

  return (
    <>
      <div>
        <button
          onClick={resetToWelcomePage}
          className="bg-custom text-white px-8 py-3 rounded font-medium hover:bg-custom/90 transition-all transform hover:scale-105 focus:outline-none focus:ring-2 focus:ring-custom focus:ring-opacity-50 newChatPnc newPartPnc"
        >
          <div className="pncBtn">
            <img src={newChatPnc} alt="Chat Icon" />
            <p className="chatPnc"> {t('newChat')}</p>
          </div>
        </button>
      </div>
      
      <div className="feedSectionPnc">
        <div className="feedbackPnc cursor-pointer" onClick={handleFeedbackButtonClick}>
          <img src={feedPnc} alt="Give Feedback icon" />
          {t('giveFeedback')}
        </div>
      </div>
    </>
  );
};

export default ActionButtons;